import { useEffect } from 'react';

import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import ObservabilityMetadata from '@rover/rsdk/src/modules/ObservabilityMetadata';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';

const useObservabilityMetadataHandler = (): void => {
  const { user } = useCurrentUserShim();
  const { language } = useFrontendConfigurationShim();
  const { pageName } = usePageContext();
  const { pathname } = useLocationContext();

  useEffect(() => {
    ObservabilityMetadata.set('currentView', pageName);
  }, [pathname]);

  useEffect(() => {
    ObservabilityMetadata.set('locale', language);
  }, [language]);

  useEffect(() => {
    ObservabilityMetadata.set('userOPK', user?.opk);
  }, [user?.opk]);
};

export default useObservabilityMetadataHandler;
